import request from '@/utils/request'
let baseUrl = '/MetaWorks/api/digitalhuman/v1/operation/dictionary/';
let commonBaseUrl = '/MetaWorks/api/digitalhuman/v1/operation/'

export function listChildren(params) {
  return request({
    url: baseUrl + 'listChildren',
    method: 'get',
    params,
  })
}
//获取敏感词
export function getSensitiveWord(data) {
  return request({
    url: commonBaseUrl + 'getSensitiveWord',
    method: 'post',
    data,
  })
}